module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Offer terms"},"et":{"title":"Offer terms"},"ru":{"title":"Offer terms"}}')
  delete Component.options._Ctor
}
